import { render, staticRenderFns } from "./BuildForm.vue?vue&type=template&id=409843c2&scoped=true"
import script from "./BuildForm.vue?vue&type=script&lang=js"
export * from "./BuildForm.vue?vue&type=script&lang=js"
import style0 from "./BuildForm.vue?vue&type=style&index=0&id=409843c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409843c2",
  null
  
)

export default component.exports